/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UndefinedAccountDeletionTaskStatsForPeriod } from './';
import {
    UndefinedAccountDeletionTaskStatsForPeriodFromJSON,
    UndefinedAccountDeletionTaskStatsForPeriodFromJSONTyped,
    UndefinedAccountDeletionTaskStatsForPeriodToJSON,
} from './';

/**
 * 
 * @export
 * @interface UndefinedAccountDeletionTaskStats
 */
export interface UndefinedAccountDeletionTaskStats {
    /**
     * 
     * @type {UndefinedAccountDeletionTaskStatsForPeriod}
     * @memberof UndefinedAccountDeletionTaskStats
     */
    currentMonth: UndefinedAccountDeletionTaskStatsForPeriod;
    /**
     * 
     * @type {UndefinedAccountDeletionTaskStatsForPeriod}
     * @memberof UndefinedAccountDeletionTaskStats
     */
    currentWeek: UndefinedAccountDeletionTaskStatsForPeriod;
    /**
     * 
     * @type {UndefinedAccountDeletionTaskStatsForPeriod}
     * @memberof UndefinedAccountDeletionTaskStats
     */
    over3Months: UndefinedAccountDeletionTaskStatsForPeriod;
    /**
     * 
     * @type {UndefinedAccountDeletionTaskStatsForPeriod}
     * @memberof UndefinedAccountDeletionTaskStats
     */
    pastMonth: UndefinedAccountDeletionTaskStatsForPeriod;
    /**
     * 
     * @type {UndefinedAccountDeletionTaskStatsForPeriod}
     * @memberof UndefinedAccountDeletionTaskStats
     */
    pastPastMonth: UndefinedAccountDeletionTaskStatsForPeriod;
    /**
     * 
     * @type {UndefinedAccountDeletionTaskStatsForPeriod}
     * @memberof UndefinedAccountDeletionTaskStats
     */
    pastWeek: UndefinedAccountDeletionTaskStatsForPeriod;
    /**
     * 
     * @type {UndefinedAccountDeletionTaskStatsForPeriod}
     * @memberof UndefinedAccountDeletionTaskStats
     */
    sinceTheBeginning: UndefinedAccountDeletionTaskStatsForPeriod;
}

/**
 * Check if a given object implements the UndefinedAccountDeletionTaskStats interface.
 */
export function instanceOfUndefinedAccountDeletionTaskStats(value: object): value is UndefinedAccountDeletionTaskStats {
    if (!('currentMonth' in value) || value['currentMonth'] === undefined) return false;
    if (!('currentWeek' in value) || value['currentWeek'] === undefined) return false;
    if (!('over3Months' in value) || value['over3Months'] === undefined) return false;
    if (!('pastMonth' in value) || value['pastMonth'] === undefined) return false;
    if (!('pastPastMonth' in value) || value['pastPastMonth'] === undefined) return false;
    if (!('pastWeek' in value) || value['pastWeek'] === undefined) return false;
    if (!('sinceTheBeginning' in value) || value['sinceTheBeginning'] === undefined) return false;
    return true;
}

export function UndefinedAccountDeletionTaskStatsFromJSON(json: any): UndefinedAccountDeletionTaskStats {
    return UndefinedAccountDeletionTaskStatsFromJSONTyped(json, false);
}

export function UndefinedAccountDeletionTaskStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UndefinedAccountDeletionTaskStats {
    if (json == null) {
        return json;
    }
    return {
        
        'currentMonth': UndefinedAccountDeletionTaskStatsForPeriodFromJSON(json['currentMonth']),
        'currentWeek': UndefinedAccountDeletionTaskStatsForPeriodFromJSON(json['currentWeek']),
        'over3Months': UndefinedAccountDeletionTaskStatsForPeriodFromJSON(json['over3Months']),
        'pastMonth': UndefinedAccountDeletionTaskStatsForPeriodFromJSON(json['pastMonth']),
        'pastPastMonth': UndefinedAccountDeletionTaskStatsForPeriodFromJSON(json['pastPastMonth']),
        'pastWeek': UndefinedAccountDeletionTaskStatsForPeriodFromJSON(json['pastWeek']),
        'sinceTheBeginning': UndefinedAccountDeletionTaskStatsForPeriodFromJSON(json['sinceTheBeginning']),
    };
}

export function UndefinedAccountDeletionTaskStatsToJSON(value?: UndefinedAccountDeletionTaskStats | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currentMonth': UndefinedAccountDeletionTaskStatsForPeriodToJSON(value['currentMonth']),
        'currentWeek': UndefinedAccountDeletionTaskStatsForPeriodToJSON(value['currentWeek']),
        'over3Months': UndefinedAccountDeletionTaskStatsForPeriodToJSON(value['over3Months']),
        'pastMonth': UndefinedAccountDeletionTaskStatsForPeriodToJSON(value['pastMonth']),
        'pastPastMonth': UndefinedAccountDeletionTaskStatsForPeriodToJSON(value['pastPastMonth']),
        'pastWeek': UndefinedAccountDeletionTaskStatsForPeriodToJSON(value['pastWeek']),
        'sinceTheBeginning': UndefinedAccountDeletionTaskStatsForPeriodToJSON(value['sinceTheBeginning']),
    };
}

